import {
  MecImage,
  PDP_SWATCH_NO_COLOUR,
  ProductImageType,
  isPrimaryProductImage,
} from '@adapters/bigcommerce/types/product';

/**
 * True when this image is an ALT from a different swatch than the active PDP colour (borrowed
 * fallback angles from {@link buildPdpImageGalleryOrder}).
 */
export function isBorrowedGalleryAlt(
  image: MecImage,
  colourFilterName: string | null | undefined
): boolean {
  if (!colourFilterName) return false;
  if (image.imageType !== ProductImageType.ALT) return false;
  if (isPrimaryProductImage(image)) return false;
  const sm = image.swatchMatch;
  if (!sm || sm === colourFilterName) return false;
  return true;
}

/**
 * Label for gallery/zoom tags: normal pipe/CMS `image.tag`, or for borrowed ALTs
 * `{colourLabel} {donorSwatch}` (e.g. EN `Colour: Blue` from `product.colour` + swatch name).
 * When the donor image also has a distinct CMS tag (e.g. “Back”), shows `Back · Colour: Blue`.
 */
export function getGalleryImageTagDisplay(
  image: MecImage,
  colourFilterName: string | null | undefined,
  colourLabel: string
): string | undefined {
  if (isBorrowedGalleryAlt(image, colourFilterName)) {
    const donor = image.swatchMatch;
    if (!donor || donor === PDP_SWATCH_NO_COLOUR) {
      return image.tag?.trim() || undefined;
    }
    const cms = image.tag?.trim();
    const colourPart = `${colourLabel} ${donor}`;
    if (cms && cms !== donor) {
      return `${cms} · ${colourPart}`;
    }
    return colourPart;
  }
  return image.tag?.trim() || undefined;
}
